export default __webpack_public_path__ + "static/media/product-1.586b52b9.jpg";